import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { enhancedConnect } from "../../utils";
import rootStyles from "../../styles/root.pcss";
import styles from "./styles.pcss";
var cn = classNames.bind(_objectSpread(_objectSpread({}, rootStyles), styles));
var _Theme = function _Theme(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('theme', cnComponentsTheme(theme), className),
    "data-t-id": "components-Theme"
  }, children);
};
export var Theme = enhancedConnect()(_Theme);